import { render, staticRenderFns } from "./CV.vue?vue&type=template&id=c8ea598e&scoped=true"
import script from "./CV.vue?vue&type=script&lang=ts"
export * from "./CV.vue?vue&type=script&lang=ts"
import style0 from "./CV.vue?vue&type=style&index=0&id=c8ea598e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ea598e",
  null
  
)

export default component.exports